export function assignMaterialToObjects(scene, objectNames, material) {
    objectNames.forEach((objectName) => {
      const object = scene.getObjectByName(objectName);
      if (object) {
        object.material = material;
      }
    });
  }